import {Upload} from 'antd';
import {RcFile, UploadFile} from 'antd/es/upload/interface';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {SubmenuTitle} from 'components/@common/widgets/submenu-title';
import {
    pickDataFromQueryByAdditionalFields,
    shouldPickDataFromQueryByAdditionalInfoKeys,
} from 'components/table/action/table-action.utils';
import {selectMetadata} from 'entities/metadata';
import {selectContextRawData} from 'modules/context/context-selector';
import {uploadFileAction} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {useRequiredQueryParams} from 'shared/hooks/use-required-query-params';
import {useQueryParams} from 'shared/utils/query-params';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

const ButtonActionUploadFileComponent: FC<ITableActionProps> = ({
    entityName,
    meta,
    wrapper: Wrapper,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const contextData = useAppSelector(selectContextRawData);
    const filterMeta = useAppSelector(selectMetadata(entityName, EEntityType.FILTER));
    const {getQueryParam} = useQueryParams();

    const {
        referenceUrl,
        additionalInfoKeys,
        actionTitle,
        actionIcon,
        requiredQueryParams,
    } = meta;

    const {isDisabled} = useRequiredQueryParams({requiredQueryParams});

    const handleUpload = (file: UploadFile<Blob>) => {
        const formData = new FormData();
        formData.append('file', file as RcFile);
        if (referenceUrl && contextData) {
            if (additionalInfoKeys && shouldPickDataFromQueryByAdditionalInfoKeys({filterMeta})) {
                const additionalData = pickDataFromQueryByAdditionalFields({additionalInfoKeys, getQueryParam});
                if (additionalData) {
                    Object
                        ?.keys(additionalData)
                        ?.forEach(key => {
                            const value = additionalData?.[key];
                            if (value) {
                                formData.append(key, value);
                            }
                        });
                }
            }

            dispatch(uploadFileAction(
                entityName,
                referenceUrl,
                formData,
                contextData,
            ));
        }
        return false;
    };

    const uploadContent = (
        <Upload
            showUploadList={false}
            beforeUpload={handleUpload}
        >
            {Wrapper ? (
                <SubmenuTitle disabled={isDisabled}>
                    {actionTitle}
                </SubmenuTitle>
            ) : (
                <ActionButton
                    {...props}
                    actionIcon={actionIcon}
                >
                    {actionTitle}
                </ActionButton>
            )}
        </Upload>
    );

    if (Wrapper) {
        return (
            <Wrapper {...props} disabled={isDisabled}>
                {uploadContent}
            </Wrapper>
        );
    }

    return uploadContent;
};
export const ButtonActionUploadFile = ButtonActionUploadFileComponent;
